import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { baseApiUrl } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

// Définition des couleurs du thème - Ajustées à orange, jaune et vert
const colors = {
  primary: "#ff8c00", // Orange
  secondary: "#ffcc00", // Jaune
  tertiary: "#4CAF50", // Vert
  light: "#f9f9f9",
  dark: "#333333",
  text: "#555555",
  border: "#eeeeee"
};

function DetailInformation() {
  const [information, setInformation] = useState(null);
  const { informationId } = useParams();
  const [informations, setInformations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(3);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const navigate = useNavigate();

  const offset = currentPage * itemsPerPage;
  const currentInformations = informations
    .filter(info => info.id !== parseInt(informationId))
    .slice(offset, offset + itemsPerPage);

  useEffect(() => {
    if (informationId) {
      baseApiUrl
        .get(`/information/${informationId}`)
        .then((response) => {
          setInformation(response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération de l'information :", error);
        });
    } else {
      console.error("L'ID de l'information est introuvable !");
    }
  }, [informationId]);

  useEffect(() => {
    setLoading(true);
    baseApiUrl
      .get("/information/liste")
      .then((response) => {
        // Filtrer les informations actives si nécessaire
        const activeInformations = response.data;

        // Trier par date (plus récente d'abord)
        const sortedInformations = activeInformations.sort((a, b) =>
          new Date(b.created) - new Date(a.created)
        );

        setInformations(sortedInformations);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des informations :", error);
        setInformations([]);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, "dd MMMM yyyy", { locale: fr }); // Format : 13 octobre 2024
    } catch {
      return "Date invalide";
    }
  };

  // Fonction pour calculer le temps de lecture (basée sur 200 mots par minute)
  const calculateReadingTime = (text) => {
    if (!text) return 1; // Temps de lecture minimum
    const words = text.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / 200);
    return minutes;
  };

  // Fonction pour tronquer les textes
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  // Gérer la recherche
  const handleSearch = (event) => {
    event.preventDefault();
    if (searchTerm.trim()) {
      const results = informations.filter(info =>
        info.titre && info.titre.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(results);
      setShowSearchResults(true);
    } else {
      setSearchResults([]);
      setShowSearchResults(false);
    }
  };

  // Navigation vers une autre information
  const navigateToInformation = (id) => {
    navigate(`/information/${id}`);
    window.scrollTo(0, 0); // Défiler vers le haut pour une meilleure expérience utilisateur
    setShowSearchResults(false); // Cacher les résultats de recherche après navigation
    setSearchTerm(""); // Réinitialiser le terme de recherche
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  if (!information) return (
    <div className="loading-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <p>Chargement des informations...</p>
    </div>
  );

  // Calcul du temps de lecture pour l'article actuel
  const readingTime = calculateReadingTime(information.contenu);

  return (
    <detail>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1 style={{ color: colors.tertiary }}>Détails de l'actualité</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-details1-all sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row align-items-center">
                <div className="col-lg-8 m-auto">
                  <div className="blog-page3-single-box">
                    <div className="heading1">
                      <div className="social-area">
                        <div className="author-area" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "15px", marginBottom: "20px" }}>
                          <div className="author" style={{ display: "flex", alignItems: "center" }}>
                            <div className="author-tumb" style={{ marginRight: "10px" }}>
                              <img
                                src={
                                  information.utilisateur && information.utilisateur.photo
                                    ? baseApiUrl.defaults.baseURL + `/image/${information.utilisateur.photo}`
                                    : "https://via.placeholder.com/30"
                                }
                                alt="Auteur"
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              />
                            </div>
                            <div>
                              <a href="#" className="author-text" style={{ display: "block", fontWeight: "600" }}>
                                {information.utilisateur
                                  ? information.utilisateur.nom
                                  : "Auteur inconnu"}
                              </a>
                              {information.utilisateur && information.utilisateur.siteWeb && (
                                <a
                                  href={information.utilisateur.siteWeb}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ fontSize: "14px", color: colors.tertiary }}
                                >
                                  {information.utilisateur.siteWeb}
                                </a>
                              )}
                            </div>
                          </div>
                          <div className="date" style={{ display: "flex", alignItems: "center" }}>
                            <a href="#" style={{ display: "flex", alignItems: "center", color: "#666" }}>
                              <img
                                src="assets/img/icons/date1.svg"
                                alt="Date"
                                style={{ marginRight: "5px", width: "16px" }}
                              />
                              {formatDate(information.created)}
                            </a>
                          </div>
                        </div>
                        <a href="#" className="time mt-16" style={{ display: "inline-flex", alignItems: "center", color: "#666" }}>
                          <img src="assets/img/icons/time1.svg" alt="Temps de lecture" style={{ marginRight: "5px", width: "16px" }} />
                          {readingTime} min
                        </a>
                      </div>
                      <h2 style={{ marginTop: "20px", marginBottom: "20px", fontWeight: "700", color: colors.primary }}>{information.titre}</h2>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="thumbnail image-anime _relative mt-20">
                    <img
                      className="w-full"
                      src={baseApiUrl.defaults.baseURL + `/image/${information.image}`}
                      alt="information"
                      style={{
                        width: "100%",
                        height: "450px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        boxShadow: `0 5px 15px rgba(0,0,0,0.1)`
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-lg-8">
              <div className="details content-area">
                {information.contenu && (
                  <article className="information-section" style={{
                    marginBottom: "30px",
                    padding: "20px",
                    backgroundColor: colors.light,
                    borderRadius: "8px",
                    borderLeft: `4px solid ${colors.primary}`
                  }}>
                    <div className="heading1">
                      <h3 style={{ marginBottom: "15px", color: colors.dark, fontWeight: "600" }}>Description</h3>
                      <p style={{ lineHeight: "1.7", color: colors.text }}>{information.contenu}</p>
                    </div>
                  </article>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog1-sidebar-area mt-40 ml-30 sm:ml-0 md:ml-0 md:mt-30 sm:mt-30">
                <div className="sidebar-details-widget_1 _search-area1">
                  <h3 style={{ color: colors.primary }}>Rechercher</h3>
                  <form onSubmit={handleSearch}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Rechercher..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          borderColor: colors.border,
                          padding: "10px 40px 10px 15px",
                          borderRadius: "5px",
                          width: "100%"
                        }}
                      />
                      <button
                        type="submit"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: colors.primary
                        }}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </form>

                  {/* Résultats de recherche */}
                  {showSearchResults && (
                    <div style={{
                      marginTop: "15px",
                      border: `1px solid ${colors.border}`,
                      borderRadius: "5px",
                      padding: "15px",
                      backgroundColor: colors.light
                    }}>
                      <h4 style={{ color: colors.tertiary, marginBottom: "10px" }}>
                        Résultats de recherche ({searchResults.length})
                      </h4>

                      {searchResults.length === 0 ? (
                        <p>Aucune actualité trouvée.</p>
                      ) : (
                        searchResults.map((result) => (
                          <div
                            key={result.id}
                            style={{
                              padding: "10px",
                              marginBottom: "10px",
                              borderBottom: `1px solid ${colors.border}`,
                              cursor: "pointer"
                            }}
                            onClick={() => navigateToInformation(result.id)}
                          >
                            <h5 style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: colors.primary,
                              marginBottom: "5px"
                            }}>
                              {truncateText(result.titre, 50)}
                            </h5>
                            <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#666" }}>
                              <i className="fa fa-calendar" style={{ marginRight: "5px" }}></i>
                              {formatDate(result.created)}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>

                <div className="sidebar-widget_1 _recent-posts mt-40">
                  <h3 style={{ color: colors.primary }}>Actualités Récentes</h3>

                  {loading ? (
                    <p>Chargement des actualités récentes...</p>
                  ) : currentInformations.length === 0 ? (
                    <p>Aucune autre actualité disponible.</p>
                  ) : (
                    currentInformations.map((info) => (
                      <div
                        className="blog1-recent-box mt-16"
                        key={info.id}
                        style={{
                          display: "flex",
                          marginBottom: "20px",
                          borderBottom: `1px solid ${colors.border}`,
                          paddingBottom: "15px",
                          cursor: "pointer",
                          transition: "transform 0.3s ease"
                        }}
                        onClick={() => navigateToInformation(info.id)}
                      >
                        <div className="recent-thumb" style={{ width: "80px", height: "80px", marginRight: "15px", flexShrink: 0 }}>
                          <img
                            src={info.image ? baseApiUrl.defaults.baseURL + `/image/${info.image}` : "default-image.jpg"}
                            alt={info.titre || "Titre inconnu"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: `2px solid ${colors.secondary}`
                            }}
                          />
                        </div>
                        <div className="heading">
                          <span className="date" style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center" }}>
                            <img src="assets/img/icons/date1.svg" alt="date" style={{ width: "14px", marginRight: "5px" }} />
                            {formatDate(info.created)}
                          </span>
                          <h5 style={{ fontSize: "15px", fontWeight: "600", marginTop: "5px", color: colors.tertiary }}>
                            {truncateText(info.titre, 60)}
                          </h5>
                        </div>
                      </div>
                    ))
                  )}

                  <div className="space30"></div>
                  <div className="row">
                    <div className="col-12 m-auto">
                      <div className="theme-pagination text-center">
                        <ReactPaginate
                          previousLabel={<i className="fa-solid fa-angle-left"></i>}
                          nextLabel={<i className="fa-solid fa-angle-right"></i>}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={informations.length > 0 ? Math.ceil((informations.length - 1) / itemsPerPage) : 1}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={3}
                          onPageChange={handlePageClick}
                          containerClassName={"pagination"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "5px",
                            listStyle: "none",
                            padding: "0"
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </detail>
  );
}

export default DetailInformation;
